import { default as BSScrollSpy } from 'bootstrap/js/src/scrollspy'

class ScrollSpy extends BSScrollSpy {}

export default ScrollSpy
